module.exports = __webpack_public_path__ + "img/teamImg22.e82037fe.jpg";